import React from "react";

import "./Icon.css";

interface Props {
    className?: string;
    iconClass: string;
    onClick?: () => void;
}

const Icon: React.FC<Props> = function ({ iconClass, className, ...props }: Props) {
    return <i className={`icon ${iconClass} ${className || ""}`} {...props} />;
};

export default Icon;
